export default function getSubItemStyle(isActive: boolean) {
  return `pl-4 w-full cursor-pointer xl:text-lg text-md text-gray-500 ${
    isActive ? "font-semibold" : "font-normal"
  }`;
}
